/** Business-dialect overrides. Sparse: a missing key falls back to en. */
export const activity = {
    wizard: {
        selectProjectStep: 'Select project',
        searchAriaLabel: 'Search clients and projects',
        searchPlaceholder: 'Search clients or projects...',
        noSearchResults: 'No clients or projects match your search',
        noActiveProjects: 'No active projects found',
        projectRequired: 'Project is required',
        feesTileHeading: 'Services',
        // NOT 'Expenses': the "Add an expense" row (expensesTileHeading, en
        // fallback 'Expenses') renders immediately below this group, and two
        // identical back-to-back headings read as a rendering bug. These tiles
        // are recoverable costs (like travel) billed on to the client.
        disbursementsTileHeading: 'Billable costs',
        expenseHint: 'Money paid to a supplier on your behalf, captured with their invoice and VAT.',
        rateHint: {
            feeEarnerProject: '{{feeEarner}} project rate',
            sharedProject: 'Shared project rate',
            account: 'Business rate',
        },
        noFeeEarnerOption: 'No team member',
    },
    import: {
        noFeeEarnerWarning: 'No User Email, so this service was imported with no team member.',
    },
    note: {
        label: 'Note',
        add: 'Add note',
        invoicedNotice: 'This activity has been invoiced, so its details are locked. You can still edit the note.',
        saveInvoiced: 'Save note',
        markerLabel: 'Open note',
    },
    badge: {
        disbursement: 'Expense',
        disbursementAbbreviated: 'Exp.',
        disbursementPlural: 'Expenses',
    },
    // Business-register narration patterns: plain business English, no legal
    // phrasing ("re:" -> "regarding", "Telephone attendance" -> "Phone call",
    // "Legal research" -> "Research"). COURT_ATTENDANCE, PRINTING, and POSTAGE
    // carry no business override: `ActivityTypeConfig.practices` (see
    // `@packages/types/activity-types.ts`) restricts those three to
    // ATTORNEY/ADVOCATE, so `getCaptureActivityTypes('BUSINESS')` excludes them
    // and the backend's `formatActivityDescriptionPatterns` never renders their
    // guidance for a BUSINESS conversation - a business override here would be
    // dead weight. The `en` base entries for those three stay (the schema, and
    // still live for ATTORNEY/ADVOCATE). The deprecated third-party types
    // (ADVOCATE, CORRESPONDENT_ATTORNEY, SHERIFF, GOVERNMENT_GAZETTE) are
    // filtered out of all rendered guidance for every practice type, so they
    // need no business wording either. The `{...}` optional-segment convention
    // is the base catalogue's (see en/activity.ts); it carries over unchanged.
    descriptionPatterns: {
        MEETING: '"Meeting with [person(s)]{ regarding [topic]}" or "Meeting with [people] at [location]"',
        // EMAIL is the one type with no dialect swap: "with subject" is already
        // plain business English, and it must match the reconciler's line
        // (`buildEmailActivityDescription`), which is locale-independent.
        EMAIL: '"Review of email from [sender]{ with subject [subject]}" or "Drafting and sending of email{ with subject [subject]}"',
        PHONE: '"Phone call with [person]{ regarding [topic]}"',
        MESSAGE: '"Message exchange with [person]{ regarding [topic]}" or, for a voice note, "Listened to voice note from [person]{ regarding [topic]}"',
        DOCUMENT_REVIEW: '"Review of [document type]{ regarding [purpose]}"',
        RESEARCH: '"Research on [topic]"',
        DRAFTING: '"Drafting of [document type]{ for [purpose]}"',
        TRAVEL_CAR: '"Travel to [destination]{ for [purpose]}"',
    },
    report: {
        projectReferenceColumn: 'Project Reference',
        projectNameColumn: 'Project Name',
        projectColumn: 'Project',
        projectFilterCount: 'Projects: {{total}}',
    },
};
